import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { AvailablePermission } from '@backoffice/shared/bo/util-permissions';
import {
  PersonManagementDomainModule,
  RoleFofIntListFacade
} from '@clean-code/backoffice/person-management/domain';
import { Role } from '@clean-code/models';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import { DataTableBaseComponent } from '@clean-code/shared/components/ui-data-table';
import {
  TableStateService,
  UiMatTableModule,
} from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { TranslocoModule } from '@jsverse/transloco';
import { NgxPermissionsModule } from 'ngx-permissions';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cc-frontoffice-int-role-management-list',
  templateUrl: './frontoffice-int-role-management-list.component.html',
  styleUrls: ['./frontoffice-int-role-management-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    RouterModule,
    UiMatTableModule,
    TranslocoModule,
    PageContainerModule,
    NgxPermissionsModule,
    PersonManagementDomainModule,
    ActionButtonModule,
  ],
  providers: [TableStateService],
})
export class FrontOfficeIntRoleManagementListComponent extends DataTableBaseComponent<Role> {
  public loading = true;
  public permissions = AvailablePermission;
  public override navigateUrl = '/settings/roles/frontoffice-int';

  constructor() {
    const service = inject(RoleFofIntListFacade);
    super(service);
    this.addFilterParams = [
      {
        key: 'tenant',
        conditions: `{ tenant: { eq:  "frontoffice-int"} }`,
      },
    ];
  }
}
